import React from 'react';

const WiredTextArea = ({
  fieldState,
  formState,
  updateFormState,
  handleValueChange,
  showValidationMessage,
  handleBlur,
  showMessage,
  label,
  ...restProps
}) => (
  <textarea value={fieldState.getValue()} onBlur={handleBlur} {...restProps} />
);

export default WiredTextArea;



// WEBPACK FOOTER //
// ./app/Assets/js/features/components/WiredTextArea.js